import { createFileRoute } from "@tanstack/react-router";
import { PaymentsPageContent } from "@/components/payments/payments-page-content";
import { useOrganizationParentGetOrganizationSettings } from "@/orval/organization-parent";
import { useParentPaymentsGetTuitionAndFees, useParentPaymentsUpdateVenmoPreference } from "@/orval/parent-payments";
import { useState } from "react";
import { PortalPageHeader } from "@/components/portal-page-header";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_app/organizations/$organizationId/parent/payments")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const [semesterId] = useState<number>();

  const { data: parentOrganizationSettings } = useOrganizationParentGetOrganizationSettings(organizationId);

  const effectiveSemesterId =
    semesterId || parentOrganizationSettings?.nextSemesterId || parentOrganizationSettings?.activeSemesterId;

  const { data: currentSemester, isFetching } = useParentPaymentsGetTuitionAndFees(
    organizationId,
    effectiveSemesterId!,
    {
      query: {
        enabled: !!effectiveSemesterId,
      },
    },
  );

  const { mutate: updateVenmoPreference, isPending: isVenmoUpdating } = useParentPaymentsUpdateVenmoPreference();
  const isVenmoPreferenceLocked = currentSemester?.isVenmoPreferenceLocked ?? false;
  const venmoPreferenceLockedAfter = currentSemester?.venmoPreferenceLockedAfter;

  const handleVenmoToggle = (useVenmo: boolean) => {
    if (!effectiveSemesterId || isVenmoPreferenceLocked) {
      return;
    }
    updateVenmoPreference({ organizationId, semesterId: effectiveSemesterId, data: { useVenmo } });
  };

  return (
    <div className="container mx-auto p-4 md:p-6">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-row items-center gap-2 print:mb-2">
          {parentOrganizationSettings && !effectiveSemesterId ? (
            <div className="flex flex-col gap-y-4 flex-1">
              <PortalPageHeader className="mb-4 print:mb-2" title="Payments" subtitle="View tuition and fees" />
              <Card>
                <CardContent className="p-6 text-muted-foreground">
                  Payments are unavailable until a semester is configured.
                </CardContent>
              </Card>
            </div>
          ) : (
            <PaymentsPageContent
              currentSemester={currentSemester}
              isFetching={isFetching}
              organizationId={organizationId}
              onVenmoToggle={handleVenmoToggle}
              isVenmoUpdating={isVenmoUpdating}
              isVenmoPreferenceLocked={isVenmoPreferenceLocked}
              venmoPreferenceLockedAfter={venmoPreferenceLockedAfter}
            />
          )}
        </div>
      </div>
    </div>
  );
}
